module.exports = __webpack_public_path__ + "img/probg2.744c62d6.png";